import styled from 'styled-components';
import { palette } from 'styled-theme';

const mobile = palette('mobile', 0);

const AtsDivider = (Component) => styled(({ large, ...props }) => <Component {...props} />)`
  /* background: ${(props) =>
    props.theme.name === 'atsDark' ? props.theme.palette.dark[3] : '#e8e8e8'}; */
  &.ant-divider-with-text:before,
  &.ant-divider-with-text:after,
  &.ant-divider-with-text-end:before,
  &.ant-divider-with-text-end:after,
  &.ant-divider-with-text-start:before,
  &.ant-divider-with-text-start:after {
    border-top: ${palette('borderStyle', 2)} !important;
    background: transparent;
  }

  .ant-divider-rail.ant-divider-rail-start,
  .ant-divider-rail.ant-divider-rail-end {
    border-block-start-color: ${({ theme }) =>
      theme.name === 'atsDark' ? theme.palette.dark[3] : '#e8e8e8'} !important;
  }

  > span {
    color: ${palette('foreground', 7)};
    font-weight: ${(props) => (props.large ? '700' : 'inherit')};
    font-size: ${(props) => (props.large ? '2rem' : 'inherit')};
    @media only screen and (max-width: ${mobile}) {
      font-weight: 400;
      font-size: 1rem;
    }
    > i {
      margin-right: 13px;
    }
    > span {
      color: ${palette('foreground', 7)};
      font-size: ${(props) => (props.large ? '2rem' : 'inherit')};
      @media only screen and (max-width: ${mobile}) {
        font-size: 1rem;
      }
    }
  }
`;

export default AtsDivider;
